import getStore from "../../store";
import { Component, h } from "preact";
import { route } from 'preact-router';
import Axios from "axios";
import * as InquiriesActions from '../../reducers/inquiries/inquiries.actions';
import { InquiryGridSearchInput } from "../inquiries/search/inquiry-grid-search-input";
import { InquiryGridSearchModal } from "../inquiries/search/inquiry-grid-search-modal";
import { hopplerApi } from "../../../../constants";
import { InquiryGrid } from "../inquiries/grid/inquiry-grid.component";
import { Inquiry } from "../../../../types/inquiries/inquiry.model"
import { ListResponse } from "../../../../types";

interface DealsLostProps {
  
}

interface DealsLostState {
  searchInput: string;
  resultCount: number;
  inquiries: ListResponse<Inquiry>;
}

const store = getStore();

export class DealsLostPage extends Component<DealsLostProps, DealsLostState> {

  /**
   *
   */
  constructor() {
    super();
    
    this.state = {
      inquiries: {
        count: 0,
        results: []
      },
      searchInput: '',
      resultCount: 0
    }
  }

  componentDidMount(): void {
    this.getLostDeals()
  }

  getLostDeals() {
    
    const url: string = `${hopplerApi.host}/kumita/inquiry/pipeline/lost`
    const params = {
      withCredentials: true,
      headers: {
        'Accept': 'application/json'
      }
    }
    
    Axios.get(url, params).then((data: any) => {
      console.log({ data })
      this.setState({ inquiries: data.data })
    })
  }

  goToSearchRoute(search?: string) {
    // console.log('Desktop mode search!');
    route('/kumita-brokers/inquiries/search?s=' + encodeURIComponent(search));
  }

  onInput(e: any) {
    console.log({ val: e.target.value })
  }

  onSubmit() {
    console.log('submitting')
  }
  
  onFilterButtonClick() {
    store.dispatch(InquiriesActions.toggleFilterVisibility());
  }

  render(props, state) {
    return (
      <div className="container-fluid py-3">
        <InquiryGrid
          stageSlug="lost"
          inquiries={this.state.inquiries} />
      </div>
    )
  }
}
